import { it as it$1 } from 'date-fns/locale';
import merge from 'lodash/merge';
import error from './error.js';
import login from './login.js';

var it = {
  language: 'it',
  country: 'it',
  name: 'Italiano',
  embeddedLocale: merge(error, login),
  flags: ['IT'],
  dateFns: it$1,
  format: {
    date: 'dd.MM.yyyy',
    dateTime: '$t(format:date) $t(format:time)',
    time: 'HH:mm',
  },
};

export { it as default };
